import repository from '@/repositories/Repository'

const resource = '/api/sites'

export default {
  get() {
    return repository.giggle.get(resource).then(r => r.data)
  },
}
